import { useSetAtom } from "jotai";
import { BASE_URL } from "../constants/api";
import { userAtom } from "../store/store";

type HttpMethod = "GET" | "POST";

interface FetchOptions {
  method: HttpMethod;
  headers?: HeadersInit;
  body?: any;
}

interface FetchResponse<T> {
  data: T;
  message: string;
  status: boolean;
}

export function useFetch() {
  const setUser = useSetAtom(userAtom);
  const request = async <T>(
    path: string,
    options: FetchOptions
  ): Promise<FetchResponse<T>> => {
    const { method, headers = {}, body } = options;
    const url = BASE_URL + path;
    const token = localStorage.getItem("token") || "";

    // 设置默认请求头
    const defaultHeaders = {
      "Content-Type": "application/json",
      Authorization: token,
      ...headers,
    };

    // 准备请求配置
    const config: RequestInit = {
      method,
      headers: defaultHeaders,
    };

    // 添加请求体
    if (body && method === "POST") {
      config.body = JSON.stringify(body);
    }

    try {
      const response = await fetch(url, config);

      // 检查响应状态
      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("token");
          setUser({
            isLogin: false,
            email: "",
            nickname: "",
          });
        }

        throw new Error(`Request error! Status: ${response.status}`);
      }

      // 解析响应数据
      const data = await response.json();

      if (!data.status) {
        throw new Error(data.message);
      }

      return data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  return { request };
}
